var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('Icon',{class:{
      "logo__img": true,
      "logo__img--desktop": !_vm.isMobile,
    },attrs:{"icon":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }